<template>
    <section>
        <div class="baoFeiApply">
            <el-form :model="questionForm" ref="" label-position="left" label-width="100px"
                style="width: 90%; margin-left: 5%">
                <el-form-item label="报废日期" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-date-picker style="width: 100%" v-model="questionForm.baoFeiDate" value-format="yyyy-MM-dd"
                        type="date" placeholder="报废日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="报废原因" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input placeholder="请输入报废原因" style="width: 100%" v-model="questionForm.reason" />
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-left: 10px" size="small" type="primary" @click="comit"
                    v-preventReClick>提交</el-button>
                <el-button @click="closeDialog" size="small">取消</el-button>
            </div>
        </div>
    </section>
</template>
<script>
import { addDeviceScraps } from '../../api/api'
export default {
    props: ['deviceinfo'],
    data() {
        return {
            questionForm: {
                reason: "",
                baoFeiDate: "",
            },
        }
    },
    methods: {
        comit() {
            var userinfo = JSON.parse(localStorage.getItem("user"))
            let deviceId = this.deviceinfo.map(item => item.id).join()
            let _params = {
                deviceIds: deviceId,
                scrapTime: this.questionForm.baoFeiDate,
                scrapReson: this.questionForm.reason,
                userId: userinfo.userId
            }
            addDeviceScraps(_params).then(datas => {
                let { status, data, message } = datas
                if (status == 300) {
                    this.$message({
                        message: message,
                        type: 'warning'
                    });
                } else if (status == 200) {
                    this.$message({
                        message: "申请成功，等待审核通过",
                        type: 'success'
                    });
                    this.$emit('select')
                    this.closeDialog();
                } else {
                    this.$message({
                        message: "申请失败",
                        type: 'success'
                    });
                }
            })
        },
        closeDialog() {
            this.questionForm.reason = ""
            this.questionForm.maintenanceType = ""
            this.$emit('func')
        }
    },
    created() {
        this.questionForm.baoFeiDate = new Date();
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/common/BaoFeiApply.vue